module.exports = __webpack_public_path__ + "c09193db3f0a7313267ba08007767436.svg";